/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListMeta
 */
export interface ListMeta {
    /**
     * 
     * @type {number}
     * @memberof ListMeta
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ListMeta
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof ListMeta
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the ListMeta interface.
 */
export function instanceOfListMeta(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListMetaFromJSON(json: any): ListMeta {
    return ListMetaFromJSONTyped(json, false);
}

export function ListMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
    };
}

export function ListMetaToJSON(value?: ListMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit': value.limit,
        'offset': value.offset,
        'total_count': value.totalCount,
    };
}

